import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { addKeywordSynonyms } from '@/scripts/add-keyword-synonyms';
import { useToast } from '@/components/ui/use-toast';

export default function RunAddSynonyms() {
  const [running, setRunning] = useState(false);
  const { toast } = useToast();

  const handleRunScript = async () => {
    setRunning(true);
    try {
      await addKeywordSynonyms();
      toast({
        title: 'Success',
        description: 'Synonyms have been added to keywords',
      });
    } catch (error) {
      console.error('Error running script:', error);
      toast({
        title: 'Error',
        description: 'Failed to add synonyms',
        variant: 'destructive',
      });
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="p-8 space-y-4">
      <h1 className="text-2xl font-semibold">Add Keyword Synonyms</h1>
      <p className="text-muted-foreground">
        This will add predefined Dutch synonyms to all keywords in the database.
      </p>
      <Button
        onClick={handleRunScript}
        disabled={running}
        className="bg-green-600 hover:bg-green-700"
      >
        {running ? 'Adding synonyms...' : 'Run Add Synonyms Script'}
      </Button>
    </div>
  );
}
